export default __webpack_public_path__ + "media/images/loop6-55718e09db1840d074bd4df56e2b533e.png";